const initialDefaultTeam = {
  defaultTeamPermissions: {},
  defaultTeamLists: [],
  defaultTeamDetail: {},
  defaultTeamCount: 0,
  defaultTeamBulletUsers: {},
  changedDefaultTeamStatus: [],
  loadingDefaultTeam: false,
  loadingDefaultTeamUsers: false,
  errorsDefaultTeam: {},
};

const defaultTeamReducer = (defaultTeam = initialDefaultTeam, action) => {
  switch (action.type) {
    case "GET_DEFAULT_TEAM_LIST_PENDING":
    case "ADD_DEFAULT_TEAM_PENDING":
    case "UPDATE_DEFAULT_TEAM_PENDING":
    case "DELETE_DEFAULT_TEAM_PENDING":
    case "GET_DEFAULT_TEAM_BY_ID_PENDING":
      return { ...defaultTeam, loadingDefaultTeam: true };

    case "GET_DEFAULT_TEAM_BULLET_USERS_PENDING":
      return { ...defaultTeam, loadingDefaultTeamUsers: true };

    case "GET_DEFAULT_TEAM_LIST_FULFILLED":
      return {
        ...defaultTeam,
        loadingDefaultTeam: false,
        defaultTeamLists: action.payload,
        defaultTeamCount: action.count,
        defaultTeamPermissions: action.permissions || {},
      };

    case "ADD_DEFAULT_TEAM_FULFILLED":
    case "UPDATE_DEFAULT_TEAM_FULFILLED":
    case "DELETE_DEFAULT_TEAM_FULFILLED":
      return {
        ...defaultTeam,
        loadingDefaultTeam: false,
        changedDefaultTeamStatus: action.payload,
      };

    case "GET_DEFAULT_TEAM_BY_ID_FULFILLED":
      return {
        ...defaultTeam,
        loadingDefaultTeam: false,
        defaultTeamDetail: action.payload,
      };

    case "GET_DEFAULT_TEAM_BULLET_USERS_FULFILLED":
      return {
        ...defaultTeam,
        loadingDefaultTeamUsers: false,
        defaultTeamBulletUsers: action.payload || {},
      };

    case "RESET_DEFAULT_TEAM_STATUS":
      return {
        ...defaultTeam,
        loadingDefaultTeam: false,
        loadingDefaultTeamUsers: false,
        changedDefaultTeamStatus: [],
        errorsDefaultTeam: {},
        defaultTeamDetail: {},
        defaultTeamBulletUsers: {},
      };

    case "GET_DEFAULT_TEAM_LIST_REJECTED":
    case "ADD_DEFAULT_TEAM_REJECTED":
    case "UPDATE_DEFAULT_TEAM_REJECTED":
    case "DELETE_DEFAULT_TEAM_REJECTED":
    case "GET_DEFAULT_TEAM_BY_ID_REJECTED":
      return {
        ...defaultTeam,
        loadingDefaultTeam: false,
        errorsDefaultTeam: action.payload,
      };

    case "GET_DEFAULT_TEAM_BULLET_USERS_REJECTED":
      return {
        ...defaultTeam,
        loadingDefaultTeamUsers: false,
        defaultTeamBulletUsers: {},
        errorsDefaultTeam: action.payload,
      };

    default:
      return defaultTeam;
  }
};

export default defaultTeamReducer;
